import { render, staticRenderFns } from "./EvalModelDeleter.vue?vue&type=template&id=03071069&scoped=true"
import script from "./EvalModelDeleter.vue?vue&type=script&lang=ts"
export * from "./EvalModelDeleter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03071069",
  null
  
)

export default component.exports